import partnerClient from "../partnerClient";

export const fetchPartnerApplications = async (clientId) => {
  const { data } = await partnerClient.get(`/clients/${clientId}/applications`);
  return data?.data ?? data ?? [];
};

export const fetchPartnerApplicationHistory = async (clientId, module, entryId) => {
  const { data } = await partnerClient.get(
    `/clients/${clientId}/applications/${module}/${entryId}/history`
  );
  return data?.data ?? data ?? [];
};

export const fetchPartnerApplicationRequests = async (params) => {
  const { data } = await partnerClient.get("/application-requests", { params });
  return data?.data ?? data ?? [];
};

export const createPartnerApplicationRequest = async (clientId, body) => {
  const { data } = await partnerClient.post(`/clients/${clientId}/application-requests`, body);
  return data?.data ?? data;
};

export const updatePartnerApplicationRequest = async (requestId, body) => {
  const { data } = await partnerClient.put(`/application-requests/${requestId}`, body);
  return data?.data ?? data;
};
